import { render, staticRenderFns } from "./ValueTemplate.vue?vue&type=template&id=5267a8f1&scoped=true"
import script from "./ValueTemplate.vue?vue&type=script&lang=js"
export * from "./ValueTemplate.vue?vue&type=script&lang=js"
import style0 from "./ValueTemplate.vue?vue&type=style&index=0&id=5267a8f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5267a8f1",
  null
  
)

export default component.exports